import React from "react";
import ReactDOM from "react-dom";
import { WOW } from "wowjs/dist/wow";
import App from "./App";
// WoW - animation on scroll
const wow = new WOW({
  boxClass: "wow", // animated element css class (default is wow)
  animateClass: "animated", // animation css class (default is animated)
  offset: 0, // distance to the element when triggering the animation (default is 0)
  mobile: true, // trigger animations on mobile devices (default is true)
  live: true, // act on asynchronously loaded content (default is true)

  scrollContainer: null, // optional scroll container selector, otherwise use window
});
wow.init();
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
